import { LinearProgress, Typography } from '@material-ui/core';
import React, { ReactElement, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';

import { selectUser } from 'entities/user/selectors';
import PageHeader from 'retired/PageHeader';
import Box from 'retired/Box';
import { useInjectEpics } from 'utils/injectEpics';
import { useInjectReducer } from 'utils/injectReducer';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';

import { CorporateDonationLogForm } from './CorporateDonationLogForm';
import epics from './epics';
import reducer from './reducer';
import { selectError, selectLoading } from './selectors';
import { FORM_IDENTIFIER, initAction, submitAction } from './types';

const withForm = reduxForm({
  form: FORM_IDENTIFIER,
});

const CorporateDonationLogFormPage = ({
  pristine,
  invalid,
  submitting,
  handleSubmit,
  form,
}): ReactElement => {
  const dispatch = useDispatch();
  useInjectEpics({ key: 'corporateDonationLogFormPage', epics });
  useInjectReducer({ key: 'corporateDonationLogFormPage', reducer });

  const error = useSelector(selectError);
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const history = useHistory();

  useEffect(() => {
    if (
      user &&
      !(
        user.hasPrivilege(Privileges.DONATION_CORPORATE_LOG) &&
        user.hasFeature(Features.EXTERNAL_CORPORATE_DONATIONS)
      )
    ) {
      history.replace('/');
    }
  });

  useEffect(() => {
    dispatch(initAction());
  }, []);

  const submit = (formData) => {
    dispatch(submitAction(formData));
  };

  return (
    <>
      <Helmet title="Log a Corporate Donation" />
      <PageHeader
        title="Log a Corporate Donation"
        subtitle="Record a corporate donation made off the platform and track your giving on the dashboard"
        onArrowClick={() => history.push('/donations/corporate')}
      />
      {(loading || submitting) && <LinearProgress />}
      <form onSubmit={handleSubmit(submit)}>
        <fieldset>
          <Box style={{ paddingTop: 0, marginBottom: 30 }}>
            <CorporateDonationLogForm
              pristine={pristine}
              invalid={invalid}
              submitting={submitting}
              form={form}
            />
          </Box>
        </fieldset>
      </form>
      {error && (
        <Typography>Failed to log your Corporate Donation. Please try again later</Typography>
      )}
    </>
  );
};

export default compose(withForm)(CorporateDonationLogFormPage);
